export const UNDER_DISPUTE_CHECK = "Under_Dispute"

export const MARKET_STATUS = {
    New: "New",
    Live: "Live",
    Waiting_for_Result: "Resolution Proposed",
    Under_Dispute: "In Review",
    Under_Appeal: "In Review",
    Closed: "Closed",
    Closing_Soon: "Coming Soon",
    Dispute_Window_Open: "In Review",
    Appeal_Window_Open: "In Review",
    Pending_Finalization: "Trading"
};

export const MARKET_STATUS_BACKGROUNDS = {
    New: "#12AAFF33",
    Live: "#22AC0033",
    Waiting_for_Result: "#22AC0033",
    Under_Dispute: "#F9AD5133",
    Under_Appeal: "#DB5F2B33",
    Closed: "#FE5C3233",
    Closing_Soon: "#F56CF133",
    Dispute_Window_Open: "#F9AD5133",
    Appeal_Window_Open: "#8559E333",
    Pending_Finalization: "#DB5F2B33"
};

export const MARKET_STATUS_TEXT_COLORS = {
    New: "#12AAFF",
    Live: "#22AC00",
    Waiting_for_Result: "#22AC00",
    Under_Dispute: "#F9AD51",
    Under_Appeal: "#DB5F2B",
    Closed: "#FE5C32",
    Closing_Soon: "#F56CF1",
    Dispute_Window_Open: "#F9AD51",
    Appeal_Window_Open: "#8559E3",
    Pending_Finalization: "#DB5F2B"
};